import { GridCustomCellProps, GridItemChangeEvent } from '@progress/kendo-react-grid';
import React from 'react';
import { NumericTextBox, NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useInternationalization } from '@progress/kendo-react-intl';
import { CpsGridCell } from './CpsGridCell';
import { CpsFieldType, EMPTY_VALUE, DEFAULT_NUMERIC_TEXTBOX_STEP } from '@cs-cms/types';

interface EditableNumericTextBoxCellProps extends GridCustomCellProps {
  onItemChange?: (event: GridItemChangeEvent) => void;
  inEdit?: boolean;
  fieldType: CpsFieldType;
  step?: number;
}

export const EditableNumericTextBoxCell: React.FC<EditableNumericTextBoxCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.dataItem[field] as number;
  const intl = useInternationalization();

  const handleChange = (event: NumericTextBoxChangeEvent): void => {
    if (!props.onItemChange) {
      return;
    }

    const newEvent: any = {
      ...event,
      dataItem: props.dataItem,
      field
    };
    props.onItemChange(newEvent);
  };

  let formattedValue = null;
  if (isNaN(value)) {
    formattedValue = props.inEdit === false ? '' : '<NaN>';
  } else if (props.fieldType === 'numeric') {
    formattedValue = intl.formatNumber(value, 'n2');
  } else {
    formattedValue = value?.toString();
  }

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={formattedValue}
    >
      {props.inEdit === false ? (
        <>{formattedValue}</>
      ) : (
        <NumericTextBox
          step={props.step ?? DEFAULT_NUMERIC_TEXTBOX_STEP}
          min={0}
          max={1000}
          format="#"
          value={value}
          onChange={handleChange}
        />
      )}
    </CpsGridCell>
  );
};
